import Cookies from 'js-cookie';
// eslint-disable-next-line import/no-cycle
import { refreshContext } from './authProvider';

const cookieDomain = () => `.${window.location.hostname.split('.').slice(-2).join('.')}`;

/**
 * Cookies may be host-only or Domain-scoped depending on the setter/browser.
 * Remove both ways so leftovers don't survive (Firefox is picky about attribute match).
 */
const removeRedirectCookie = (name: string) => {

  Cookies.remove(name, { domain: cookieDomain(), path: '/' });
  Cookies.remove(name, { path: '/' });

};

/** Deduplicate concurrent handoffs (checkAuth is invoked from several places). */
let cookieHandoffInProgress: Promise<string | null> | null = null;

export const cookieOrStorageRefreshToken = async () => {

  const token = Cookies.get('redirect_refreshToken');
  if (token) {

    localStorage.setItem('refreshToken', token);
    removeRedirectCookie('redirect_refreshToken');
    return token;

  }

  return localStorage.getItem('refreshToken');

};

export const cookieOrStorageToken = async (needsNewRoles = true) => {

  const token = Cookies.get('redirect_token');

  if (!token) {

    return localStorage.getItem('token');

  }

  if (cookieHandoffInProgress) {

    return cookieHandoffInProgress;

  }

  cookieHandoffInProgress = (async () => {

    await cookieOrStorageRefreshToken();

    localStorage.removeItem('lastSavedCustomer');
    sessionStorage.removeItem('currentCustomer');

    localStorage.setItem('token', token);
    removeRedirectCookie('redirect_token');

    if (needsNewRoles) {

      try {

        await refreshContext(token);

      } catch (e) {

        // Tokens are already in localStorage; don't fail checkAuth (that would
        // logout and clear them). App boot refreshContext retries after reload.
        // eslint-disable-next-line no-console
        console.error('Failed to refresh context during cookie handoff', e);

      }

    }
    window.location.reload();
    return token;

  })();

  return cookieHandoffInProgress;

};
